module.exports = __webpack_public_path__ + "static/media/icon-close.2eb510fc.svg";